export const manifest = {
  screens: {
    scr_l2634f: { name: "Головна", route: "/", position: {"x":160,"y":220} },
    scr_bs5mg9: { name: "Стрижки", route: "/services/haircuts", position: {"x":160,"y":2200} },
    scr_jkq99g: { name: "Фарбування", route: "/services/coloring", position: {"x":1560,"y":2200} },
    scr_ilavtr: { name: "Завивка", route: "/services/perms", position: {"x":2960,"y":2200} },
    scr_nz1wrc: { name: "Укладка", route: "/services/styling", position: {"x":4360,"y":2200} },
    scr_umary0: { name: "Манікюр і педикюр", route: "/services/nails", position: {"x":5760,"y":2200} },
    scr_u7o53u: { name: "Прокол вух", route: "/services/piercing", position: {"x":7160,"y":2200} },
    scr_1ixliq: { name: "Курси", route: "/courses", position: {"x":160,"y":4180} },
  },
  sections: {
    sec_dm8d8m: { name: "Home", x: 0, y: 0, width: 1520, height: 1180 },
    sec_e6t2e2: { name: "Services Catalog", x: 0, y: 1980, width: 8520, height: 1180 },
    sec_5o0pwu: { name: "Courses", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_dm8d8m", children: [
      { kind: "screen", id: "scr_l2634f" },
    ] },
    { kind: "section", id: "sec_e6t2e2", children: [
      { kind: "screen", id: "scr_bs5mg9" },
      { kind: "screen", id: "scr_jkq99g" },
      { kind: "screen", id: "scr_ilavtr" },
      { kind: "screen", id: "scr_nz1wrc" },
      { kind: "screen", id: "scr_umary0" },
      { kind: "screen", id: "scr_u7o53u" },
    ] },
    { kind: "section", id: "sec_5o0pwu", children: [
      { kind: "screen", id: "scr_1ixliq" },
    ] },
  ],
}
